"use strict";
const cullingMixin = {
  cullArea: null,
  cullable: false,
  cullableChildren: true
};

export { cullingMixin };
//# sourceMappingURL=cullingMixin.mjs.map
